import axios from 'axios';
import { handle401 } from './apiAuth';

// Isolated client for the AI Roadmaps stack (roadmaps.app.lxop.in), mirroring the other service
// clients. Routes are identical to the ones the main stack served (/roadmaps/...),
// and both read the same DynamoDB tables and export bucket, so this is a transport change
// only.
//
// Falls back to the main API when unset, which keeps a stale build working
// against the old endpoints until the roadmaps functions are removed from the
// main stack.
const BASE_URL =
  (typeof window !== 'undefined' && window.electronEnv?.roadmapsApiUrl) ||
  process.env.REACT_APP_ROADMAPS_API_URL ||
  'https://roadmaps.app.lxop.in';

const roadmapsApi = axios.create({ baseURL: BASE_URL, timeout: 60000 });

roadmapsApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('lxops_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

roadmapsApi.interceptors.response.use(
  (res) => res,
  (err) => {
    handle401(err);
    return Promise.reject(err);
  }
);

export default roadmapsApi;
